var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{attrs:{"title":"Client","dark":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"client-name"},[_vm._v("\n          Name: "+_vm._s(_vm.client.name)+"\n        ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e3670e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewClient/ClientMetadata.vue
// module id = null
// module chunks = 